import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import DonatePage from './pages/DonatePage';
import ReceiptPage from './pages/ReceiptPage';
import PressKitPage from './pages/PressKitPage';
import LiveQRPage from './pages/LiveQRPage';
import SongRequestsPage from './pages/SongRequestsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminRegisterPage from './pages/AdminRegisterPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/receipt" element={<ReceiptPage />} />
        <Route path="/press-kit" element={<PressKitPage />} />
        <Route path="/live" element={<LiveQRPage />} />
        <Route path="/live/songs" element={<SongRequestsPage />} />

        {/* Admin — hidden from public nav, noindex */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/register" element={<AdminRegisterPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              {({ admin }) => <AdminDashboardPage admin={admin} />}
            </ProtectedAdminRoute>
          }
        />

        {/* Legacy album routes redirect to home */}
        <Route path="/album" element={<Navigate to="/" replace />} />
        <Route path="/album-unlock" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
